import moment from 'moment'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {useFormContext} from 'react-hook-form'
import {
  ResponseTotalScanActivity,
  ScanActivityDto,
  ScanActivityResponse,
} from '../../../../model/cleaningStatus.model'
import {CLEANING_STATUS_SERVICES} from '../../../../services/cleaning-status.service'
import {KTableLoading} from '../../../../../../components/UI'

export const ModalInformation = () => {
  const {setValue, watch} = useFormContext()
  const showModalProgrammingServiceDetails = watch('showModalProgrammingServiceDetails')
  const cellData = watch('cellData')
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<ResponseTotalScanActivity<ScanActivityResponse[]>>(null)

  const handleClose = () => {
    setValue('showModalProgrammingServiceDetails', false)
  }

  useEffect(() => {
    if (cellData && showModalProgrammingServiceDetails) {
      getActivitiesByCampamentoList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalProgrammingServiceDetails, cellData])

  const getActivitiesByCampamentoList = async () => {
    try {
      let dto: ScanActivityDto = {
        ModuloId: cellData.moduloId,
        HabitacionId: cellData.habitacionId,
        Fecha: cellData.fecha,
        EscaneoId: cellData.escaneoId,
        pageNumber: 1,
        size: 1000,
      }
      setLoading(true)
      const {data: response} = await CLEANING_STATUS_SERVICES.getListEscaneoActividad(dto)
      if (!response.error) {
        setData(response)
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      className='modal fade'
      show={showModalProgrammingServiceDetails}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Información De Programación</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {loading && <KTableLoading />}
          <form>
            <div className='table-responsive'>
              <table className='table table-bordered align-middle mb-0'>
                <tbody>
                  <tr>
                    <td colSpan={4} className='fw-bold bg-light'>
                      Responsable de limpieza
                    </td>
                  </tr>

                  <tr className='bg-light fw-bold'>
                    <td>Nombres</td>
                    <td>Celular</td>
                    <td colSpan={2}></td>
                  </tr>

                  <tr>
                    <td className='fw-semibold'>{data?.NombreUsuario}</td>
                    <td className='fw-semibold'>{data?.Celular}</td>
                    <td colSpan={2}></td>
                  </tr>

                  <tr>
                    <td colSpan={4} className='bg-light' style={{height: '20px'}}></td>
                  </tr>

                  <tr className='bg-light fw-bold'>
                    <td>Servicio</td>
                    <td>Hora inicio</td>
                    <td>Hora Fin</td>
                    <td>Duración</td>
                  </tr>

                  {data?.data?.map((activity) => (
                    <tr key={activity.EscaneoActividadId}>
                      <td>{activity.Actividad}</td>
                      <td>{moment(activity.HoraIni, 'HH:mm:ss').format('HH:mm')}</td>
                      <td>{moment(activity.HoraFin, 'HH:mm:ss').format('HH:mm')}</td>
                      <td>{`${Math.floor(activity.Duracion)} min`}</td>
                    </tr>
                  ))}

                  <tr className='fw-bold'>
                    <td colSpan={2}></td>
                    <td>Total</td>
                    <td>{`${Math.floor(data?.TotalDuracion)} min`}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}
